<div class="flex-parent">
  <div class="login-form-div">
    <mat-icon class="really-big-icon icon-green pulse-icon" >check_circle</mat-icon>
    <div class="header">
      <h3 class="text-details">
        {{'callback.message' | translate}}
      </h3>
    </div>
    <div class="additional-options">
      <app-back-button></app-back-button>
    </div>
  </div>
</div>
